<ng-container cdkPortalOutlet></ng-container>

<div class="arrow" qtPopoverArrow></div>
